<template>
  <div>
    <GlobalHeader :showHeader="showHeader"/>
    <div>
      <router-view/>
    </div>
    <GlobalFooter />
<!--    <contact-us />-->
  </div>

</template>

<script>
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
import ContactUs from "../components/contactUs";
// import {loadJsMethods} from '@/utils/tools'
export default {
  name: 'BasicLayout',
  components: {
    ContactUs,
    GlobalHeader,
    GlobalFooter
  },
  data () {
    return {
      showHeader:false,
    }
  },
  computed: {
  },
  created () {
    // const script = document.createElement('script');
    // script.src = '/static/js/vendor/jquery-1.12.4.min.js';
    // script.onload = () => {
    //   // 文件加载完毕后的回调
    //   console.log('External JS file loaded!');
    //   this.onloadOtherJs()
    // };
    // document.head.appendChild(script);
  },
  mounted () {
    // loadJsMethods()
    console.log("显示")
    this.scalePage(1.0)

  },
  methods: {
    // onloadOtherJs(){
    //   setTimeout(()=>{
    //     const script = document.createElement('script');
    //     script.src = '/static/js/main.js';
    //     script.onload = () => {
    //       // 文件加载完毕后的回调
    //       console.log('External JS file loaded!');
    //       this.showHeader = true
    //     };
    //     document.head.appendChild(script);
    //   },1000)
    // },
    scalePage(scale) {
      const newScale = `width=device-width, initial-scale=${scale}, maximum-scale=${scale}, minimum-scale=${scale}`;
      this.viewport = newScale;
      this.updateViewportTag(newScale);
    },
    updateViewportTag(content) {
      const meta = document.querySelector('meta[name="viewport"]');
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        const newMeta = document.createElement('meta');
        newMeta.setAttribute('name', 'viewport');
        newMeta.setAttribute('content', content);
        document.head.appendChild(newMeta);
      }
    },
  }
}
</script>
